<template>
    <div class="row no-gutters mb-3" v-if="!$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED">
        <div class="col-12 col-lg-3 mb-3 mb-md-0">
            <h6 class="font-weight-bold text-uppercase text--gray">{{ TEXTS.render(`BOOKING_SUMMARY_BOOKING_DATE`) }}</h6>
            <div>{{formatDate}}</div>
        </div>
        <div class="col-12 col-lg-3 mb-3 mb-md-0">
            <h6 class="font-weight-bold text-uppercase text--gray">{{ TEXTS.render(`BOOKING_SUMMARY_REF_NO`) }}</h6>
            <!-- US415 Removing depracated code - Franco  -->
            <!-- <div>{{ 'CRN' + ($store.getters.GET_CRN || '606571') }}</div> -->
            <div v-for="booking in workOrderResponseBookings" :key="booking.CRN">
                {{ booking.CRN }}
            </div>

        </div>
        <div class="col-12 col-lg-5 mb-3 mb-md-0">
            <h6 class="font-weight-bold text-uppercase text--gray">{{ TEXTS.render(`BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_3`) }}</h6>
            <!-- {{ wasteTypeList }} -->
            <div v-for="(summarydetails, index) in wasteTypeList" :key="index">
                <div v-if="summarydetails.indexOf('<b>') == -1" v-html="summarydetails" />
            </div>
        </div>
    </div>
    <div class="mb-3" v-else>
        <template v-if="bookingCompletedData">
            <div class="mb-1" v-for="CrnGroup in bookingCompletedData.buildSummaryV2" :key="CrnGroup.CRN">
                <div class="row pb-1" v-show="CrnGroup.CRN">
                    <div class="col-12 font-weight-bold">{{ CrnGroup.CRN && `CRN${CrnGroup.CRN}` }}</div>
                </div>
                <div class="row">
                    <div class="col-4" v-html="TEXTS.render(`BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_1`, null, null, {upperCase : true})"></div>
                    <div class="col-4" v-html="TEXTS.render(`BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_2`, null, null, {upperCase : true})"></div>
                    <div class="col-4" v-html="TEXTS.render(`BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_3`, null, null, {upperCase : true})"></div>
                </div>
                <!-- repeating -->
                <div class="row" v-for="service in CrnGroup.services" :key="CrnGroup.CRN + service.name">
                    <div class="col-4">{{ service.requestedCompletionDate }}</div>
                    <div class="col-4">{{ service.name }}</div>
                    <div class="col-4">
                        <span class="d-block w-100" v-for="w in service.wastes">{{ w.presentationName }}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Texts from '../../../../common/utils/Texts'
    import BookingCompletedData from '../../../../common/utils/BookingCompletedData';
    import helper from '../../../../helper';
    import DateNoTz from '../../../../common/utils/DateNoTz';
    import ServerDateMixin from '../../../../common/mixins/ServerDateMixin';

    export default {
        mixins: [ServerDateMixin],
        data() {
            return {
                bookingCompletedData: null
            };
        },
        mounted() {
            this.bookingCompletedData = new BookingCompletedData();

            // Use the function inside the class
            this.bookingCompletedData.buildName = helper.buildName;
            this.bookingCompletedData.objectsGroupBy = helper.objectsGroupBy;
            this.bookingCompletedData.setDateNoTz = DateNoTz;
        },
        computed: {
            TEXTS : ()=> Texts,
            wasteTypeList() {
                return this.$store.getters.GET_BOOKING_SUMMARY_DETAILS.list;
            },
            formatDate() {
                var serverDate = this.getServerDate()

                return serverDate ? new DateNoTz(serverDate).formatDayDdMonYyyy().split(',')[1].trim() || '04 April 2019' : null
            },
            workOrderResponseBookings(){
                var bookingCrns = Array.isArray(this.$store.getters.GET_CRN) ? this.$store.getters.GET_CRN : []
                return bookingCrns
            },
            products() {
                if (this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
                    return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS;
                }
                return [];
            },
            bookingCompletedDetails() {
                return this.$store.getters.GET_BOOKING_COMPLETED_DETAILS;
            },
            services() {
                return this.$store.getters.GET_SERVICES.list || [];
            },
            bookingsDates() {
                return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES;
            }
        },
        watch: {
            'products': function(products) {
                this.bookingCompletedData.wastesSource = products;
            },
            'services': function(services) {
                this.bookingCompletedData.serviceSource = services;
            },
            'bookingsDates': function(dates) {
                this.bookingCompletedData.bookingsDatesSource = dates;
            },
            'bookingCompletedDetails': function(details) {
                if (details) {
                    this.bookingCompletedData.data = details;
                }
            }
        }
    }
</script>